export async function convertImageFileToPdf(imageFile: File): Promise<File> {
  const { default: jsPDF } = await import("jspdf");

  let fileToLoad = imageFile;
  const isHeic =
    imageFile.type === "image/heic" ||
    imageFile.type === "image/heif" ||
    imageFile.name.toLowerCase().endsWith(".heic") ||
    imageFile.name.toLowerCase().endsWith(".heif");

  if (isHeic) {
    const heic2any = (await import("heic2any")).default;
    const jpegBlob = await heic2any({ blob: imageFile, toType: "image/jpeg", quality: 0.92 });
    const blob = Array.isArray(jpegBlob) ? jpegBlob[0] : jpegBlob;
    fileToLoad = new File(
      [blob],
      imageFile.name.replace(/\.heic$/i, ".jpg").replace(/\.heif$/i, ".jpg"),
      { type: "image/jpeg" },
    );
  }

  const objectUrl = URL.createObjectURL(fileToLoad);
  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image();
    image.onload = () => resolve(image);
    image.onerror = (e) => {
      console.error(
        "[convertImageFileToPdf] Image failed to load:",
        fileToLoad.name,
        fileToLoad.type,
        e,
      );
      reject(e);
    };
    image.src = objectUrl;
  });

  const orientation = img.width >= img.height ? "landscape" : "portrait";
  const pdf = new jsPDF({ orientation, unit: "pt" });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  const imgAspect = img.width / img.height;
  const pageAspect = pageWidth / pageHeight;
  let drawWidth: number;
  let drawHeight: number;
  if (imgAspect > pageAspect) {
    drawWidth = pageWidth;
    drawHeight = pageWidth / imgAspect;
  } else {
    drawHeight = pageHeight;
    drawWidth = pageHeight * imgAspect;
  }

  const x = (pageWidth - drawWidth) / 2;
  const y = (pageHeight - drawHeight) / 2;

  const canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;
  const ctx = canvas.getContext("2d");
  if (!ctx) throw new Error("Canvas 2D context not available");
  ctx.drawImage(img, 0, 0);

  const isPng = imageFile.type === "image/png";
  const dataUrl = canvas.toDataURL(isPng ? "image/png" : "image/jpeg", 0.92);

  pdf.addImage(dataUrl, isPng ? "PNG" : "JPEG", x, y, drawWidth, drawHeight);

  const pdfBlob = pdf.output("blob");
  const pdfName = imageFile.name.replace(/\.[^.]+$/, "") + ".pdf";
  URL.revokeObjectURL(objectUrl);
  return new File([pdfBlob], pdfName, { type: "application/pdf" });
}
